import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../../assets/styles/cardNews/CardHorizontalWithLargeThumbnail.module.css";
import img from "../../../assets/images/thumbnail_default.jpg";
import RatingIndicator from "../RatingIndicator";
import PressNDate from "./PressNDate";
import { Obscure } from "../\bobscuredImage";
// import {checkMycorpAPI, addMycorpAPI, delMycorpAPI, checkScrapAPI, delScrapAPI, addScrapAPI} from "../../../apis/my_service";
// import {Checkbox} from "@mui/material";
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
// import BookmarkIcon from "@mui/icons-material/Bookmark";

const CardHorizontalWithThumbnail = ({ news }) => {
  const navigate = useNavigate();
  // const [isMycorp, setIsMycorp] = useState(false); // 마이기업인지 체크
  // const [isScraped, setIsScraped] = useState(false); // 스크랩된 뉴스인지 체크

  // useEffect(() => {
  //     checkMycorpAPI(data.stockcode).then((res) => {
  //         if (res) {
  //             setIsMycorp(true);
  //         } else {
  //             setIsMycorp(false);
  //         }
  //     })
  //     checkScrapAPI(data.newsid).then((res) => {
  //         if (res) {
  //             setIsScraped(true);
  //         } else {
  //             setIsScraped(false);
  //         }
  //     });
  // }, [isScraped, setIsMycorp]);
  const moveToSingleNews = () => {
    navigate(`/single-news/${news.newsid}`);
  };
  const moveToTimeline = () => {
    navigate(`/${news.newsid}/timeline`);
  };

  // const addMycorp = () => {
  //     addMycorpAPI(data.stockcode).then((res) => {
  //         if (res) {setIsMycorp(res);}
  //     });
  // }
  //
  // const delMycorp = () => {
  //     delMycorpAPI(data.stockcode).then((res) => {
  //         if (res) {setIsMycorp(false);}
  //     });
  // }
  //
  // const addScrap = () => {
  //     addScrapAPI(data.newsid).then((res) => {
  //         if (res) {setIsScraped(res);}
  //     });
  // }
  //
  // const delScrap = () => {
  //     delScrapAPI(data.newsid).then((res) => {
  //         if (res) {setIsScraped(false);}
  //     });
  // }

  return (
    <div className={styles.card_container}>
      <div className={styles.card_contents} onClick={moveToSingleNews}>
        {news && (
          <>
            <div className={styles.card_top}>
              <RatingIndicator
                signal={news.signal}
                percent={news.staticsentimental.percent}
              />
              <span className={styles.stockname}>{news.stockname}</span>
            </div>
            <p className={styles.title}>{news.subject}</p>
            <p className={styles.summary}>{news.summary}</p>
            <div className={styles.card_footer}>
              {/*<span>{news.press}·{news.registdate.slice(-5)}</span>*/}
              <PressNDate press={news.press} date={news.registdate} />
              {news.samenewscounts > 0 && (
                <span className={styles.newscnt} onClick={moveToTimeline}>
                  {`${news.samenewscounts}건 연관뉴스 보기 >`}{" "}
                </span>
              )}
            </div>
          </>
        )}
      </div>
      <div className={styles.card_thumbnail_container}>
        {news && (
          <Obscure text={news?.press}>
            <img
              className={styles.thumbnail}
              src={news.imgsrc || img}
              alt={news.subject}
            />
          </Obscure>
        )}
        {/*<div className={styles.overlay}>*/}
        {/*    <div className={styles.square}>*/}
        {/*        <Checkbox*/}
        {/*            sx={{ color: "#f7f9fa" }}*/}
        {/*            size="medium"*/}
        {/*            disableRipple={true}*/}
        {/*            checked={isMycorp}*/}
        {/*            icon={<FavoriteBorderIcon />}*/}
        {/*            checkedIcon={<FavoriteIcon sx={{ color: "#e63d44" }} />}*/}
        {/*            onClick={isMycorp ? delMycorp : addMycorp}*/}
        {/*        />*/}
        {/*    </div>*/}
        {/*    <div className={styles.square}>*/}
        {/*        <Checkbox*/}
        {/*            sx={{ color: "#f7f9fa" }}*/}
        {/*            size="medium"*/}
        {/*            disableRipple={true}*/}
        {/*            checked={isScraped}*/}
        {/*            icon={<BookmarkBorderIcon />}*/}
        {/*            checkedIcon={<BookmarkIcon />}*/}
        {/*            onClick={isScraped ? delScrap : addScrap}*/}
        {/*        />*/}
        {/*    </div>*/}
        {/*</div>*/}
      </div>
    </div>
  );
};

export default CardHorizontalWithThumbnail;
